import { useEffect } from "react";
import { handleConfirmPayment, handlePlayVideoInFactor, handleRetryPayment, useAppSelector } from "redux-share";
import IMAGES from "../../../../../images/importImages";
import Image from "next/image";
import { shallowEqual } from 'react-redux'
import { conditions } from "helpers";
import { ConditionName } from "interfaces";
import dynamic from "next/dynamic";

const PrintIcon = dynamic(() => import("../../icon-components/printIcon"));
const LayerIcon = dynamic(() => import("../../icon-components/layerIcon"));

const Factor = () => {

    const { factor } = useAppSelector(({ user: { factor } }) => ({ factor }), shallowEqual);
    const { params } = useAppSelector(({ videoData: { params } }) => ({ params }), shallowEqual);

    useEffect(() => {
        handleConfirmPayment()
    },[])

    return (
        <div className={conditions(ConditionName.isTouchScreenPortrait) ? "pl-m-4" : "pl-mx-[112px] pl-my-8"}>
            {factor ? (
                <>
                    <div className={`pl-flex ${conditions(ConditionName.isTouchScreenPortrait) ? "pl-flex-col-reverse pl-p-4" : "pl-py-[74px] pl-px-[56px]"} pl-justify-between pl-items-center pl-bg-lime-500/[0.3] dark:pl-bg-lime-500/[0.6] pl-rounded-[8px]`}>
                        <p className={`pl-text-lime-600 dark:pl-text-lime-500 ${conditions(ConditionName.isTouchScreenPortrait) ? "pl-mt-4 pl-text-[20px] pl-text-center" : "pl-text-[32px]"} font-extrabold`}>بسته ی شما با موفقیت خریداری شد.</p>
                        <img src={IMAGES.paymentSuccess} />
                    </div>
                    <div className={`pl-flex pl-justify-end pl-items-center pl-gap-6 pl-mb-2 ${conditions(ConditionName.isTouchScreenPortrait) ? "pl-mt-3" : "pl-mt-6"}`}>
                        <PrintIcon className="pl-fill-z-secondary-600 dark:pl-fill-secondary pl-cursor-pointer" onClick={() => window.print()}/>
                    </div>
                    <div className={`pl-flex pl-flex-col pl-gap-6 pl-bg-secondary-200 dark:pl-bg-dark-2 pl-rounded-[8px] ${conditions(ConditionName.isTouchScreenPortrait) ? "pl-px-4 pl-pt-4 pl-pb-[31px]" : "pl-px-10 pl-pt-6 pl-pb-[72px]"}`}>
                        <div className={`pl-flex pl-items-center ${conditions(ConditionName.isTouchScreenPortrait) ? "pl-gap-2" : "pl-gap-[18px]"}`}>
                            <LayerIcon className="pl-fill-gray-800 dark:pl-fill-z-secondary-50" />
                            <p className="pl-fill-gray-800 dark:pl-fill-z-secondary-50 pl-text-4 pl-font-medium">جزئیات خرید بسته</p>
                        </div>
                        <div className="pl-flex pl-justify-between pl-items-center pl-gap-2">
                            <p className="pl-text-[14px] pl-font-normal pl-text-z-secondary-600 dark:pl-text-z-secondary-50">تعداد استفاده</p>
                            <div className="pl-border pl-border-dashed pl-border-dark-5 pl-flex-1"></div>
                            <p>{factor!.max_usage} مرتبه</p>
                        </div>
                        <div className="pl-flex pl-justify-between pl-items-center pl-gap-2">
                            <p className="pl-text-[14px] pl-font-normal pl-text-z-secondary-600 dark:pl-text-z-secondary-50">زمان اعتبار بسته</p>
                            <div className="pl-border pl-border-dashed pl-border-dark-5 pl-flex-1"></div>
                            <p>{factor!.active_duration} روزه</p>
                        </div>
                        <div className="pl-flex pl-justify-between pl-items-center pl-gap-2">
                            <p className="pl-text-[14px] pl-font-normal pl-text-z-secondary-600 dark:pl-text-z-secondary-50">شماره پیگیری</p>
                            <div className="pl-border pl-border-dashed pl-border-dark-5 pl-flex-1"></div>
                            <p>{params.transaction_id}</p>
                        </div>
                        <button onClick={handlePlayVideoInFactor} className="pl-bg-main-light hover:pl-bg-main-700 pl-text-white pl-transition-colors pl-duration-300 pl-w-full pl-flex pl-justify-center pl-items-center pl-gap-3 pl-py-4 pl-rounded-[10px] pl-mt-6">
                            <Image src={IMAGES.videoCircle} width={20} height={20} />
                            <span className="pl-text-[15px] pl-font-bold">پخش فیلم</span>
                        </button>
                    </div>
                </>
            ) : (
                <>
                    <div className={`pl-flex ${conditions(ConditionName.isTouchScreenPortrait) ? "pl-flex-col-reverse pl-p-4" : "pl-py-[74px] pl-px-[56px]"} pl-justify-between pl-items-center pl-bg-red-300/[0.3] dark:pl-bg-red-300/[0.5] pl-rounded-[8px]`}>
                        <div className={`${conditions(ConditionName.isTouchScreenPortrait) && "pl-px-8"}`}>
                            <p className={`pl-text-red-600 dark:pl-text-red-500 ${conditions(ConditionName.isTouchScreenPortrait) ? "pl-text-[20px] pl-text-center" : "pl-text-[32px]"} font-extrabold`}>متاسفانه پرداخت شما ناموفق بود. </p>
                            <p className={`${conditions(ConditionName.isTouchScreenPortrait) ? "pl-text-[14px]" : "pl-text-[16px]"} pl-font-bold pl-text-z-secondary-600 dark:pl-text-white`}>در صورت کسر وجه از حساب شما مبلغ آن طی 72 ساعت آینده به حساب شما بازخواهد گشت.</p>
                        </div>
                        <img src={IMAGES.paymentFail} />
                    </div>
                        <div className={`pl-flex pl-flex-col pl-gap-6 pl-bg-secondary-200 dark:pl-bg-dark-2 pl-rounded-[8px] ${conditions(ConditionName.isTouchScreenPortrait) ? "pl-mt-4 pl-px-4 pl-pt-4 pl-pb-[31px]" : "pl-mt-16 pl-px-10 pl-pt-6 pl-pb-[72px]"}`}>
                        <div className="pl-flex pl-justify-between pl-items-center pl-gap-2">
                            <p className="pl-text-[14px] pl-font-normal pl-text-z-secondary-600 dark:pl-text-z-secondary-50">شماره پیگیری</p>
                            <div className="pl-border pl-border-dashed pl-border-dark-5 pl-flex-1"></div>
                            <p>{params.transaction_id}</p>
                        </div>
                        <button onClick={handleRetryPayment} className={`pl-text-[15px] pl-font-bold pl-bg-main-light hover:pl-bg-main-700 pl-text-white pl-transition-colors pl-duration-300 pl-w-full pl-flex pl-justify-center pl-items-center pl-gap-3 pl-py-4 pl-rounded-[10px] pl-mt-6`}>تلاش مجدد</button>
                    </div>
                </>
            )}
        </div>
    )
}

export default Factor;